export enum ActiveTab {
  Advisor = 'Advisor',
  Adjudication = 'Adjudication',
  Decision = 'Decision',
  Summary = 'Summary',
  TeamRoom = 'TeamRoom',
  DummyLLMChat = 'DummyLLMChat',
  Charter = 'Charter',
  CharterPrep = 'CharterPrep',
  CharterGroup = 'CharterGroup',
}

/** True for the in-game charter channel tabs (Prep Coach / Group Moderator). */
export const isCharterTab = (
  tabId: string | number | null | undefined
): boolean =>
  tabId === ActiveTab.CharterPrep || tabId === ActiveTab.CharterGroup

/** Professor monitoring: one tab per team player (e.g. ai-player-42). */
export const AI_PLAYER_TAB_PREFIX = 'ai-player-'

export const makeAIPlayerTabId = (memberId: string | number): string =>
  `${AI_PLAYER_TAB_PREFIX}${memberId}`

export const parseAIPlayerTabId = (
  tabId: string | number | null | undefined
): string | null => {
  const id = tabId == null ? '' : String(tabId)
  if (!id.startsWith(AI_PLAYER_TAB_PREFIX)) return null
  const memberId = id.slice(AI_PLAYER_TAB_PREFIX.length)
  return memberId || null
}

export const isAIPlayerTab = (
  tabId: string | number | null | undefined
): boolean => {
  if (tabId == null) return false
  const id = String(tabId)
  return id === ActiveTab.DummyLLMChat || id.startsWith(AI_PLAYER_TAB_PREFIX)
}

export enum SenderType {
  Player = 1,
  Chatbot = 2,
  Professor = 3,
}

export enum AIPlayerSenderType {
  Player = 'player',
  Bot = 'bot',
}

export enum ChatMode {
  NEGOTIATION_HISTORY = 'negotiationHistory',
  TEST_CHAT = 'testChat',
  PREVIOUS_CHAT = 'previousChat',
}

export enum TestChatType {
  Advisor = 'advisor',
  AIPlayer = 'aiPlayer',
}
